import { Rocket, Store } from "lucide-react";
import { Reveal } from "./Reveal";
import { SectionHeading } from "./Section";

const CARDS = [
  {
    icon: Rocket,
    title: "Buat yang mau mulai usaha",
    text: "Sedang merencanakan usaha? Gunakan KalkuBisnis untuk memperkirakan biaya, memahami kebutuhan modal, dan menyusun gambaran harga jual serta target penjualan sebelum melangkah lebih jauh.",
  },
  {
    icon: Store,
    title: "Buat yang sudah berjualan",
    text: "Sudah berjualan? Gunakan KalkuBisnis untuk meninjau HPP dan harga jual, mencatat penjualan, serta memahami angka usaha dengan lebih teratur.",
  },
];

export function Audience() {
  return (
    <section className="bg-slate-50 py-16 sm:py-24">
      <div className="mx-auto max-w-6xl px-4 sm:px-6 lg:px-8">
        <Reveal>
          <SectionHeading title="Cocok untuk yang Mau Mulai maupun yang Sudah Berjualan" />
        </Reveal>
        <div className="mt-12 grid gap-5 md:grid-cols-2">
          {CARDS.map((c, i) => (
            <Reveal key={c.title} delay={i * 0.12}>
              <article className="h-full rounded-2xl border border-slate-200 bg-white p-6 shadow-sm sm:p-8">
                <span className="flex h-11 w-11 items-center justify-center rounded-xl bg-teal-50 text-teal-700">
                  <c.icon className="h-5 w-5" aria-hidden="true" />
                </span>
                <h3 className="mt-4 text-lg font-semibold text-slate-900 sm:text-xl">{c.title}</h3>
                <p className="mt-2 text-sm leading-relaxed text-slate-600 sm:text-base">{c.text}</p>
              </article>
            </Reveal>
          ))}
        </div>
        <Reveal delay={0.2}>
          <p className="mx-auto mt-8 max-w-2xl text-center text-xs leading-relaxed text-slate-500">
            KalkuBisnis membantu kamu mengambil keputusan dengan data — bukan menggantikan
            pertimbangan bisnismu, dan tidak menjamin hasil tertentu.
          </p>
        </Reveal>
      </div>
    </section>
  );
}
